import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { LaytimeChartReportRequest } from 'hooks/useExcelAPI';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { TXT_CANCEL, TXT_LAYTIME_CHART_REPORT_FILTER, TXT_RUN_REPORT } from '../../../../../shared/translations';
import { LaytimechartReportFilterContent } from './LaytimechartReportFilterContent';

interface LaytimechartReportFilterProps extends LaytimeChartReportRequest {
  onCancel: () => void;
  onSubmit: (params: LaytimeChartReportRequest) => void;
}

const schema = yup.object().shape({
  startDate: yup.date().nullable().required(),
  endDate: yup.date().nullable().required()
});

export const LaytimechartReportFilter = (props: LaytimechartReportFilterProps) => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const defaultStartDate = new Date(`Jan 1 $${currentYear}`);
  const defaultEndDate = new Date(`Dec 31 $${currentYear}`);
  const counterParties: string[] = [];
  const ports: string[] = [];
  const { handleSubmit, setValue, formState, control } = useForm<LaytimeChartReportRequest>({
    resolver: yupResolver(schema),
    defaultValues: {
      startDate: props.startDate ?? defaultStartDate,
      endDate: props.endDate ?? defaultEndDate,
      counterParties: props.counterParties ?? counterParties,
      portIds: props.portIds ?? ports,
      traderId: props.traderId ?? undefined,
      operatorId: props.operatorId ?? undefined,
      showChildDeals: props.showChildDeals ?? false
    }
  });

  const onSubmit: SubmitHandler<LaytimeChartReportRequest> = async (params) => {
    props.onSubmit(params);
  };

  return (
    <>
      <Dialog open={true} maxWidth="xs" fullWidth>
        <DialogTitle align="center">{t(TXT_LAYTIME_CHART_REPORT_FILTER).toUpperCase()}</DialogTitle>
        <DialogContent>
          <form id="frm-laytime-chart-report" onSubmit={handleSubmit(onSubmit)}>
            <LaytimechartReportFilterContent
              control={control}
              setValue={setValue}
              formState={formState}
              publicMode={false}
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.onCancel} color="secondary">
            {t(TXT_CANCEL)}
          </Button>
          <Button disabled={!formState.isValid} type="submit" form="frm-laytime-chart-report">
            {t(TXT_RUN_REPORT)}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
